module.exports = __webpack_public_path__ + "static/media/580919_557056830995242_505147555_n.321dadc9.jpg";